import { customType } from 'drizzle-orm/sqlite-core'
import { z } from 'zod'

/** Campaign lifecycle in tenant DB: live or inactive only (draft/review flow removed). */
export enum CampaignStatus {
  PUBLISHED = 'published',
  ARCHIVED = 'archived'
}

const campaignStatusValues = Object.values(CampaignStatus) as string[]

/** Legacy DB values coerced to {@link CampaignStatus.PUBLISHED} at read time until migrations run. */
const LEGACY_STATUSES_COERCED_TO_PUBLISHED = new Set(['draft', 'to_review', 'rejected'])

export const campaignStatusSchema = z.nativeEnum(CampaignStatus)

export const campaignStatusType = customType<{ data: CampaignStatus, notNull: true, default: true }>({
  dataType() {
    return 'text'
  },
  fromDriver(value) {
    if (typeof value === 'string') {
      if (campaignStatusValues.includes(value)) {
        return value as CampaignStatus
      }
      if (LEGACY_STATUSES_COERCED_TO_PUBLISHED.has(value)) {
        return CampaignStatus.PUBLISHED
      }
    }
    throw new Error(`Invalid campaign status: ${value}`)
  }
})
